// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"98762164","455":"d9375dee","644":"1615b6a5"}[chunkId] + ".chunk.js";
};